<template>
    <b-row>
        <b-col cols="12" class="py-5">
            <h3>¿Conoces algún abonado?</h3>
            <h5>Introduce aquí su número de abonado para activar la promoción</h5>
            <template v-if="! promocion_confirmada">
                <ValidationObserver tag="form" ref="observer" @submit.prevent="buscar()">
                    <div class="input-group">
                        <input class="form-control w-auto" id="input-referidos" v-model="n_abonado" placeholder="Número de abonado"/>
                        <button class="button large-button" type="submit" :disabled="disabled || !canSubmit">Verificar</button>
                    </div>
                    <FormCaptchaComponent
                        ref="captcha"
                        :siteKey="sitekey"
                        @success="onCaptchaVerified"
                        @expired="onCaptchaInvalidHandler"
                        @error="onCaptchaInvalidHandler"
                    />
                </ValidationObserver>
            </template>
            <template v-else>
                <div class="input-group">
                    <input class="form-control w-auto" id="input-referidos" v-model="n_abonado" placeholder="Número de abonado" disabled/>
                    <button class="button large-button" style="background-color: #80bf78;"><i class="fa fa-check-circle"></i></button>
                </div>
            </template>            
            <b-modal 
                v-if="abonado" 
                id="abonado-modal" 
                title="Datos del abonado" 
                centered
                @ok="confirmarAbonado()"
                @cancel="cancelar()"
            >
                <b-row>
                    <b-col cols="12">
                        <ul>
                            <li>Nombre: {{ abonado.name }} {{ abonado.surnames }}</li>
                        </ul>
                    </b-col>
                    <b-col cols="12" class="text-center">
                        <h3>¿Es correcto este abonado?</h3>
                    </b-col>
                </b-row>
            </b-modal>
        </b-col>
    </b-row>
</template>

<script>
    import FormCaptchaComponent from '@/modules/ui/FormCaptchaComponent.vue';

    export default {
        components: { FormCaptchaComponent },
        props: {
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                n_abonado: null,
                abonado: null,
                promocion_confirmada: false,
                captchaToken: null,
                sitekey: process.env.VUE_APP_CLOUDFLARE_SITE_KEY
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            canSubmit() {
                return !!this.captchaToken;
            }
        },
        methods: {
            onCaptchaVerified(token) {
                this.captchaToken = token;
            },
            onCaptchaInvalid() {
                this.captchaToken = null;
            },
            onCaptchaInvalidHandler() {
                this.onCaptchaInvalid();
                this.$refs.captcha?.reset({ keepFeedback: true });
            },
            resetCaptcha() {
                this.captchaToken = null;
                this.$refs.captcha?.reset();
            },
            async buscar() {
                if (!this.canSubmit) return;

                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar.referido'), {
                        filters: {
                            tid: this.configuracion.hash_teatro
                        },
                        n_abonado: this.n_abonado,
                        captchaToken: this.captchaToken
                    }).then(res => {
                        this.abonado = res.data.data;
                        setTimeout(() => {
                            this.$bvModal.show('abonado-modal');
                        }, 200);   
                    }).catch(error => {
                        this.$toast.error('Abonado no encontrado');
                        this.resetCaptcha();
                    }); 
                }
            },
            confirmarAbonado() {
                this.promocion_confirmada = true;
                this.$emit('confirmado', this.abonado.id);
            },
            cancelar() {
                this.resetCaptcha();
                this.abonado = null;
                this.n_abonado = null;
            }
        }
    }
</script>